import { ORDER_STATUS } from 'src/constants/order';
import { IValidation, TBooleanInNumber } from 'src/types/main';

export enum GENDER {
  MALE = 'male',
  FEMALE = 'female',
}

export interface ICustomerProfile {
  id: number;
  name: string;
  gender: GENDER | null;
  birth_day: string | null;
  mobile: string;
  email: string | null;
  created_at: string | null;
  first_order: ICustomerOrder | null;
  last_order: ICustomerOrder | null;
  order_total_sum: number;
  order_total_count: number;
  order_total_avg: number;
  wallet: number;
  status: TBooleanInNumber;
  //
  is_draft?: boolean;
}

export interface ICustomerOrder {
  id: number;
  order_key: number;
  order_total: number;
  order_status: ORDER_STATUS;
  customer_id: number;
  created_at: string;
}

export interface ICustomerProfileValidation {
  isValid: boolean;
  email: IValidation;
}
